import classes from './ServiceBlock.module.scss'

type Props = {
    title: string;
    label: string;
    icon: string;
    selected: boolean;
    setSelectedBlockLabel: (label: string)=>void;
}

export const ServiceBlock = ({title, label, icon, selected, setSelectedBlockLabel }: Props) => {
    return (
            <button className={`${classes.block} ${selected ? classes.selected : ''}`} onClick={()=>setSelectedBlockLabel(label)}>
                <img src={icon} alt={`${label} icon`}/>
                <span>{title}</span>
            </button>
    )
}